"use client";

import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { Hamburger } from "@/components/ui/hamburger";

import { HeaderReturnVariantProps } from "./header.variants";

interface HeaderNavProps {
  styles: HeaderReturnVariantProps;
  opened: boolean;
  onHandleMenu: (opened: boolean) => void;
}

export function HeaderActions({ styles, opened, onHandleMenu }: HeaderNavProps) {
  const { theme, setTheme } = useTheme();

  return (
    <div className={styles.actionsMenu()}>
      <Button
        size="sm"
        appearance="ghost"
        color="grayDark"
        className={styles.iconButton()}
        onClick={() => setTheme(theme === "light" ? "dark" : "light")}
        isIconOnly
      >
        <Icon name="blending_mode" />
      </Button>
      {/* <Button
        size="sm"
        appearance="ghost"
        color="grayDark"
        className={styles.iconButton()}
        onClick={() => {}}
        isIconOnly
      >
        <Icon name="search" />
      </Button> */}
      <Hamburger
        active={opened}
        ariaControls="header-menu"
        toggle={() => onHandleMenu(!opened)}
        className={styles.hamburgerButton()}
      />
    </div>
  );
}
